// slices/customerProfileSlice.js
import { apiSlice } from "./apiSlice";
import { GET_CUSTOMER_PROFILE_URL } from "../constants";

export const customerProfileSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCustomerProfile: builder.query({
      query: () => ({
        url: GET_CUSTOMER_PROFILE_URL,
        method: "GET",
      }),
    }),
  }),
});

export const { useFetchCustomerProfileQuery } = customerProfileSlice;
